class BuyXGetY extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.getProduct = this.dataset.getProduct;
    this.buyProduct = this.dataset.buyProduct;

    this.cartItems = document.querySelector('cart-items');
    if (!this.cartItems) return;

    this.checkCart();
  }

  validateGiftItem(cart_items, gift_variant_id) {
    return cart_items.find(line_item => line_item.id == gift_variant_id) ? true : false;
  }

  validateRequiredItem(cart_items, required_variant_id) {
    return cart_items.find(line_item => line_item.id == required_variant_id) ? true : false;
  }

  getGiftItem(cart_items, gift_variant_id) {
    return cart_items.find(line_item => line_item.id == gift_variant_id && line_item.final_line_price === 0);
  }

  getRequiredQuantity(cart_items, required_variant_id) {
    return cart_items.find(line_item => line_item.id == required_variant_id).quantity;
  }

  getGiftItemIndex(cart_items, gift_variant_id) {
    if (!this.validateGiftItem(cart_items, gift_variant_id)) return null;
    return cart_items.findIndex(line_item => line_item.id == gift_variant_id && line_item.final_line_price === 0) + 1;
  }

  updateMinBogoQuantity(cart_items) {
    const requiredQuantity = this.getRequiredQuantity(cart_items, this.buyProduct);
    const giftItemIndex = this.getGiftItemIndex(cart_items, this.getProduct);

    giftItemIndex == null?this.checkCart():this.cartItems.updateQuantity(giftItemIndex, requiredQuantity);
  }

  checkCart() {
    if (!this.form) return;

    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (cart.status) {
        this.handleErrorMessage(cart.description);
        return;
      }

      const hasGift = this.validateGiftItem(cart.items, this.getProduct);
      const hasRequired = this.validateRequiredItem(cart.items, this.buyProduct);

      if (!hasGift) {
        if(hasRequired) {  
          this.addGiftToCart();
          if(this.getRequiredQuantity(cart.items, this.buyProduct) != 1){
            this.updateMinBogoQuantity(cart.items);
          }                      
          return;
        }
      } else {
        if(hasRequired) {
          const equalQuantity = cart.items.find(line_item => line_item.id == this.getProduct && line_item.final_line_price === 0).quantity == this.getRequiredQuantity(cart.items, this.buyProduct)? true: false;
          !equalQuantity? this.updateMinBogoQuantity(cart.items): true;
        } else {
          const giftItemIndex = this.getGiftItemIndex(cart.items, this.getProduct);
          this.cartItems.updateQuantity(giftItemIndex, 0);
          return;
        }
      }
    })
    .catch(e => {
      console.error(e);
    });
  }

  addGiftToCart() {
    if (!this.form) return;

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    config.body = formData;

    if (this.cartItems) {
      formData.append('sections', this.cartItems.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
    } else {
      formData.append('sections', this.getCartIconBubbleSectionToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
    }

    fetch(`${routes.cart_add_url}`, config)
    .then(response => { return response.text(); })
    .then(state => {
      const parsedState = JSON.parse(state);

      this.cartItems.getSectionsToRender().forEach((section => {
        const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML =
        this.cartItems.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      this.cartItems.disableLoading();
    })
    .catch(e => {
      console.error(e);

      if (!this.cartItems) return;
      this.cartItems.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      document.getElementById('cart-errors').textContent = window.cartStrings.error;
      this.cartItems.disableLoading();
    });
  }
}

customElements.define('buy-x-get-y', BuyXGetY);
